import { SupportApi } from "@/services/support-service"
import { useSystemFeedback } from "@/stores/systemFeedback"
import { defineStore } from "pinia"
import type { ApiError } from "@/types/api"

export const useSupport = defineStore("supports", {
  state: () => {
    return {
      api: new SupportApi()
    }
  },

  actions: {
    async createSupport(data: FormData) {
      try {
        const response = await this.api.sendSupport(data)
        return response
      } catch (error) {
        this.handleErrors(error as ApiError)
      }
    },

    handleErrors(error: ApiError) {
      const errorMessage = error?.response
        ? `backend.${error.response.data.detail}`
        : "requestError.default"
      useSystemFeedback().setFeedback({ type: "danger", text: errorMessage })
    }
  }
})
